import React from "react";
import { classNames } from "Utils/utils";
import CareWatchOverflowCount from "./CareWatchOverflowCount";

const timesheetValueTone = (value) => {
  const text = String(value || "").toLowerCase();
  if (text.startsWith("not ")) return "is-warn";
  if (text.startsWith("marked")) return "is-ok";
  return "";
};

const CareWatchSignalCheck = ({
  analyser,
  moreLabels = [],
  tooltipId,
  timesheetMarked,
}) => {
  const extras = (Array.isArray(moreLabels) ? moreLabels : []).filter(Boolean);

  return (
  <div className="care-watch-signal-check">
    <div className="care-watch-signal-check__cell">
      <span className="care-watch-signal-check__label">Analyser</span>
      {extras.length ? (
        <span className="care-watch-signal-check__value care-watch-signal-check__value--row">
          <span>{analyser}</span>
          <CareWatchOverflowCount labels={extras} tooltipId={tooltipId} />
        </span>
      ) : (
        <span className="care-watch-signal-check__value">{analyser}</span>
      )}
    </div>
    <div className="care-watch-signal-check__divider" aria-hidden="true" />
    <div className="care-watch-signal-check__cell">
      <span className="care-watch-signal-check__label">Incident on timesheet</span>
      <span
        className={classNames(
          "care-watch-signal-check__value",
          timesheetValueTone(timesheetMarked)
        )}
      >
        {timesheetMarked}
      </span>
    </div>
  </div>
  );
};

export default CareWatchSignalCheck;
